import { FieldsEnum, FormsEnum, PaymentTypeEnum } from 'app/shared/enums';
import {
  clearFieldValue,
  getDictionaryFromSelector,
  getFormValue,
  getVisibleDictionaryFromSelector,
  setHiddenDictionaries,
  setMessageVisibility,
  changeFieldValueAndUpdate,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { DictionaryEntry } from 'app/services/dict.service';

const isInternalTransfer = ({ key }: DictionaryEntry) =>
  key === PaymentTypeEnum.InternalTransfer;

const formName = FormsEnum.TravelPaymentForm;

export const tryCheckAndHidePaymentMethod = () => {
  const numberOfInstallments = getFormValue(
    FieldsEnum.NumberOfInstallments,
    formName
  );

  const dictionary = getVisibleDictionaryFromSelector(
    'payment.paymentType_dictionary',
    formName
  );

  const hasOneEntry = dictionary && dictionary.length === 1;

  setQuestionVisibility({
    key: 'payment.paymentType',
    visible: !hasOneEntry && !!numberOfInstallments,
    formName,
  });

  if (hasOneEntry) {
    changeFieldValueAndUpdate(
      'payment.paymentType',
      dictionary![0].key,
      formName
    );
  }
};

const payment = {
  travelNumberOfInstallmentsChanged() {
    const numberOfInstallments = getFormValue(
      FieldsEnum.NumberOfInstallments,
      formName
    );
    const dictionary =
      getDictionaryFromSelector(formName, 'payment.paymentType_dictionary') ||
      [];

    let hiddenDictionaryEntries = [];

    const hasInstallmentsSelected = numberOfInstallments > 1;

    if (hasInstallmentsSelected) {
      hiddenDictionaryEntries.push('payment.paymentType_internal_transfer');
    }

    setHiddenDictionaries({
      formName,
      hiddenDictionaryEntries,
    });

    if (dictionary?.length > 1) {
      clearFieldValue(FieldsEnum.PaymentType, formName);
      tryCheckAndHidePaymentMethod();
    }

    if (!dictionary?.some(isInternalTransfer)) {
      return;
    }

    setMessageVisibility({
      formName,
      key: 'internalTransferOnlyIfOneInstallmentSelected',
      visible: hasInstallmentsSelected,
    });
  },

  tryCheckAndHidePaymentMethod,
};

export default payment;
